import renderImage from '../../../../source/importImg'
import IMAGE from '../actionDeviceImages'
import SliderBox from '../../../ReusableComponents/SliderBox/SliderBox'
import servoPopupStyle from './ServoDetailsPopup.module.css'
import createStyle from '.././ActionsCreate.module.css'
import zIndex from '@material-ui/core/styles/zIndex'


function DeviceMotorIdImg(props) {
    const {
        showDeviceModal,
        setShowDeviceModal,
        showCloseBtn,
        DEVICEBUTTONS,
        inactiveBtnH,
        inactiveBtnseventeen,
        inactiveBtneightteen,
        isShowNewUI = 'false',
    } = props
    const connectedDevice = sessionStorage.getItem('connectedDevice')

    const largeBox = {
        top: '10vh',
        right: '0',
        height: showDeviceModal ? '70vh' : '20vh',
        width: showDeviceModal ? '57vw' : '10vw',
        opacity: showDeviceModal ? 1 : 0,
        pointerEvents: showDeviceModal ? 'auto' : 'none',
        overflow: 'visible',
    }

    return (
        // showDeviceModal &&
        <>
            {
                // className={servoPopupStyle.servoPopupMain}
                <div
                    className={servoPopupStyle.motorPopupMain}
                    style={largeBox}
                >
                    <div
                        className={servoPopupStyle.servoPopupBox}
                        style={{ border: '2rem' }}
                    >
                        <img
                            className={servoPopupStyle.closeBtn}
                            style={
                                // !showCloseBtn ? { visibility: 'hidden' } : null,
                                { zIndex: '20000000' }
                            }
                            src={renderImage('clos')}
                            onClick={setShowDeviceModal}
                        />
                        <div className={servoPopupStyle.servoPopupBody}>
                            {/* Image wrapper — auto-sizes to the rendered image.
                                All button overlays are children of this wrapper,
                                so their % positions track the actual image area
                                regardless of container size. */}
                            <div className={servoPopupStyle.imageWrapper}>
                                <img
                                    src={IMAGE[connectedDevice.toUpperCase()]}
                                    className={servoPopupStyle.anatomyImg}
                                    alt={connectedDevice}
                                />
                                {/* Button overlays — positioned relative to image */}
                                <div
                                    className={
                                        createStyle[
                                            `create-${connectedDevice.toLowerCase()}`
                                        ]
                                    }
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                    }}
                                >
                                    {
                                        DEVICEBUTTONS[
                                            `${connectedDevice.toUpperCase()}`
                                        ]
                                    }

                                    {connectedDevice !== 'Hexapod' && (
                                        <img
                                            className={`${
                                                createStyle['sc-toggle-button']
                                            } ${
                                                createStyle[
                                                    `sc-btn-H-${isShowNewUI}`
                                                ]
                                            }`}
                                            src={inactiveBtnH}
                                        />
                                    )}

                                    {connectedDevice === 'Hexapod' && (
                                        <>
                                            <img
                                                className={`${
                                                    createStyle[
                                                        'sc-toggle-button'
                                                    ]
                                                } ${
                                                    createStyle[
                                                        `sc-btn-${connectedDevice.toLowerCase()}-seventeen-${isShowNewUI}`
                                                    ]
                                                }`}
                                                src={inactiveBtnseventeen}
                                            />
                                            <img
                                                className={`${
                                                    createStyle[
                                                        'sc-toggle-button'
                                                    ]
                                                } ${
                                                    createStyle[
                                                        `sc-btn-${connectedDevice.toLowerCase()}-eighteen-${isShowNewUI}`
                                                    ]
                                                }`}
                                                src={inactiveBtneightteen}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default DeviceMotorIdImg
